import { User } from './user';

export class Provider {
  ahfoz_number!: string;
  practice_number?: string;
  provider_name!: string;
  provider_type!: string;
  details?: string;
  contact_person_name?: string;
  contact_person_national_id?: string;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  email?: string;
  logo_path?: string;
  primary_color!: string;
  tax_certificate_number?: string;
  tax_certificate_exiry_date?: number;
  tax_certificate_path?: string;
  // Stage 5 PR 44, 2026-05-16 — BE-driven daily tax compliance flag.
  provider_is_tax_compiant?: boolean;
  ahfoz_certificate_path?: string;
  practice_certificate_path?: string;
  date_joined?: number;
  date_approved?: number;
  location_latitude?: number;
  location_longitude?: number;
  status!: string;
  date_deleted?: number;
  user_uuid!: string;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  isPending() {
    return this.status.toLocaleLowerCase() == 'pending';
  }

  isApproved() {
    return this.status.toLocaleLowerCase() == 'approved';
  }

  isSuspended() {
    return this.status.toLocaleLowerCase() == 'suspended';
  }

  isTerminated() {
    return this.status.toLocaleLowerCase() == 'terminated';
  }

  constructor(data: any) {
    this.ahfoz_number = data.ahfoz_number;
    this.practice_number = data.practice_number;
    this.provider_name = data.provider_name;
    this.provider_type = data.provider_type;
    this.details = data.details;
    this.contact_person_name = data.contact_person_name;
    this.contact_person_national_id = data.contact_person_national_id;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.date_joined = data.date_joined;
    this.logo_path = data.logo_path;
    this.primary_color = data.primary_color;
    this.tax_certificate_number = data.tax_certificate_number;
    this.tax_certificate_exiry_date = data.tax_certificate_exiry_date;
    this.tax_certificate_path = data.tax_certificate_path;
    this.provider_is_tax_compiant = data.provider_is_tax_compiant;
    this.ahfoz_certificate_path = data.ahfoz_certificate_path;
    this.practice_certificate_path = data.practice_certificate_path;
    this.date_approved = data.date_approved;
    this.location_latitude = data.location_latitude;
    this.location_longitude = data.location_longitude;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.user_uuid = data.user_uuid;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
